import { render } from "./CRMDepartmentHigh.vue?vue&type=template&id=0fc8913e&scoped=true"
import script from "./CRMDepartmentHigh.vue?vue&type=script&lang=js"
export * from "./CRMDepartmentHigh.vue?vue&type=script&lang=js"

import "./CRMDepartmentHigh.vue?vue&type=style&index=0&id=0fc8913e&scoped=true&lang=css"
import "./CRMDepartmentHigh.vue?vue&type=style&index=1&id=0fc8913e&lang=css"
script.render = render
script.__scopeId = "data-v-0fc8913e"

export default script